import React, { Component } from "react";

class Ssn extends Component {
  componentDidMount() {}

  render() {
    const ss = { ssn: this.props.ssn };
    const diplaySsn =
      this.props.diplaySsn !== undefined
        ? this.props.diplaySsn
        : this.props.ssn;
    return (
      <div
        role="button"
        tabIndex={0}
        onClick={() =>
          this.props.handleNewSearchClick(this, "SSN", this.props.ssn, ss)
        }
      >
        <span className={"url-link"}>{diplaySsn}</span>
      </div>
    );
  }
}

export default Ssn;



// WEBPACK FOOTER //
// ./src/components/searchresults/Ssn.js